export default "/_next/static/b73715deaa1160031f1c4f4110df27be.png";